import { TagContainer, TagFadedContainer, TagReverseContainer, TagSquareContainer } from './styled'

const COLORS = [
  '#FF7FB2',
  '#E5FF7F',
  '#FF99C1',
  '#99FFC1',
  '#FFEA99',
  '#93FE4C',
  '#FF1975',
  '#99FF99',
  '#EFFFB2',
  '#4CDBFE',
  '#FEDB4C',
  '#FFA365',
  '#FFB27F',
  '#99EAFF',
  '#75FF19',
  '#3284FF',
  '#FFC199',
  '#FFB2D1',
  '#FF65E0',
  '#FF19D1',
  '#65FF65',
  '#FF6565',
  '#FE4C4C',
  '#DBFE4C',
  '#19D1FF',
  '#D1FFB2',
  '#FF99EA',
  '#65FFE0',
  '#7FFF7F',
  '#B2FFD1',
  '#B2EFFF',
  '#EA99FF',
  '#FFD632',
  '#4CFE93',
  '#65E0FF',
  '#32D6FF',
  '#FF7FE5',
  '#FFD119',
  '#7FB2FF',
  '#19FF75',
  '#7FFFE5',
  '#FE934C',
  '#19FF19',
  '#A365FF',
  '#D6FF32',
  '#E0FF65',
  '#FF7519',
  '#C199FF',
  '#FF3232',
  '#9999FF',
  '#4CFE4C',
  '#FF3284',
  '#B2D1FF',
  '#934CFE',
  '#EAFF99',
  '#A3FF65',
  '#FF65A3',
  '#99FFEA',
  '#FF7F7F',
  '#32FFD6',
  '#C1FF99',
  '#FFD1B2',
  '#FE4C93',
  '#4CFEDB',
  '#84FF32',
  '#E065FF',
  '#FFE065',
  '#7FFFB2',
  '#FF9999',
  '#4C93FE',
  '#FFE57F',
  '#D119FF',
  '#7FE5FF',
  '#6565FF',
  '#D1FF19',
  '#FFB2B2',
  '#32FF84',
  '#7F7FFF',
  '#FF1919',
  '#65FFA3',
  '#FF8432',
  '#E57FFF',
  '#B27FFF',
  '#D632FF',
  '#B2FFB2',
  '#FFEFB2',
  '#99C1FF',
  '#DB4CFE',
  '#65A3FF',
  '#B2B2FF',
  '#B2FF7F',
  '#32FF32',
  '#19FFD1',
  '#FF32D6',
  '#1975FF',
  '#FFB2EF',
  '#EFB2FF',
  '#FE4CDB',
  '#D1B2FF',
  '#B2FFEF',
  '#E7CFB8',
]

function convertToStableColor(key) {
  const int = key.split('').reduce((acc, value) => {
    return acc + value.charCodeAt(0)
  }, 0)
  return COLORS[int % COLORS.length]
}

function Tag({ children, color, rawColor, className }) {
  return (
    <TagContainer customColor={color} rawColor={rawColor} className={className}>
      {children}
    </TagContainer>
  )
}

function TagAuto({ stableString, children, className }) {
  const color = convertToStableColor(stableString)
  return (
    <Tag className={className} rawColor={color}>
      {children}
    </Tag>
  )
}

function TagReverse({ children, className, color, dataTestId, rawColor }) {
  return (
    <TagReverseContainer data-testid={dataTestId} className={className} customColor={color} rawColor={rawColor}>
      {children}
    </TagReverseContainer>
  )
}

function TagFaded({ children, className, color, rawColor, fade = 0.94 }) {
  return (
    <TagFadedContainer className={className} customColor={color} rawColor={rawColor} fade={fade}>
      {children}
    </TagFadedContainer>
  )
}

function TagSquare({ children, className, color, rawColor, hasUppercase }) {
  return (
    <TagSquareContainer className={className} customColor={color} rawColor={rawColor} hasUppercase={hasUppercase}>
      {children}
    </TagSquareContainer>
  )
}

Tag.Auto = TagAuto
Tag.Reverse = TagReverse
Tag.Faded = TagFaded
Tag.Square = TagSquare

export default Tag
